/**
 * Interval packing (spec §3.5): every drawn thing in a channel zone claims an
 * x-interval on a track. First-fit, shortest span first, so a nested arc
 * sits lower than the arc that spans it; ties by `order` (source step number
 * then exit name) keep the result deterministic. Touching intervals share.
 */
export interface Interval { id: string; lo: number; hi: number; order: string }

export function packIntervals(items: Interval[]): { track: Map<string, number>; count: number } {
  const sorted = [...items].sort(
    (a, b) => a.hi - a.lo - (b.hi - b.lo) || a.lo - b.lo || (a.order < b.order ? -1 : a.order > b.order ? 1 : 0),
  )
  const tracks: Interval[][] = []
  const track = new Map<string, number>()
  for (const item of sorted) {
    let placed = false
    for (let t = 0; t < tracks.length && !placed; t++) {
      if (tracks[t].every((o) => o.hi <= item.lo || o.lo >= item.hi)) {
        tracks[t].push(item)
        track.set(item.id, t)
        placed = true
      }
    }
    if (!placed) {
      tracks.push([item])
      track.set(item.id, tracks.length - 1)
    }
  }
  return { track, count: tracks.length }
}
